var e={addText:"Add to basket",customizeText:"Customize & buy",share:"Share"};export{e as addToCartTranslations};
